import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Typography, Button, Stack } from '@mui/material';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import AutoAwesomeRoundedIcon from '@mui/icons-material/AutoAwesomeRounded';
import { formatDateToYmd } from '../commons/utils';

export const SubscriptionBanner = () => {
    const { subscription } = useSelector((state: any) => state.auth);

    if (!subscription) return null;

    const { is_trial, payment_vencido, trialEndsAt } = subscription;

    if (payment_vencido) {
        return (
            <Box sx={{ 
                boxSizing: 'border-box',
                background: 'linear-gradient(90deg, #d32f2f 0%, #f44336 100%)', 
                color: '#fff', 
                py: 2, 
                px: { xs: 2, sm: 3 }, 
                display: 'flex', 
                alignItems: { xs: 'flex-start', sm: 'center' }, 
                justifyContent: 'space-between',
                flexDirection: { xs: 'column', sm: 'row' },
                boxShadow: '0 4px 20px rgba(211, 47, 47, 0.25)',
                zIndex: 9999,
                gap: 2
            }}>
                <Stack direction="row" alignItems="center" spacing={1.5} sx={{ flex: 1 }}>
                    <WarningRoundedIcon sx={{ fontSize: 26, animation: 'pulse 2s infinite', flexShrink: 0 }} />
                    <Box sx={{ flex: 1 }}>
                        <Typography variant="subtitle2" sx={{ fontWeight: 800, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                            Suscripción Vencida
                        </Typography>
                        <Typography variant="body2" sx={{ fontWeight: 500, opacity: 0.9 }}>
                            El pago de su suscripción se encuentra vencido. Por favor, regularice su estado para evitar interrupciones.
                        </Typography>
                    </Box>
                </Stack>
                <Button 
                    variant="outlined" 
                    color="inherit" 
                    size="small"
                    sx={{ 
                        borderWidth: 2, 
                        fontWeight: 700, 
                        borderRadius: 2,
                        flexShrink: 0,
                        alignSelf: { xs: 'flex-end', sm: 'center' },
                        whiteSpace: 'nowrap',
                        '&:hover': { borderWidth: 2, backgroundColor: 'rgba(255,255,255,0.1)' } 
                    }}
                >
                    Contactar Soporte
                </Button>
                <style>
                    {`
                    @keyframes pulse {
                        0% { transform: scale(1); opacity: 1; }
                        50% { transform: scale(1.15); opacity: 0.7; }
                        100% { transform: scale(1); opacity: 1; }
                    }
                    `}
                </style>
            </Box>
        );
    }

    if (is_trial) {
        return (
            <Box sx={{ 
                boxSizing: 'border-box',
                background: 'linear-gradient(90deg, #1976d2 0%, #0d47a1 100%)', 
                color: '#fff', 
                py: 2, 
                px: { xs: 2, sm: 3 }, 
                display: 'flex', 
                alignItems: { xs: 'flex-start', sm: 'center' }, 
                justifyContent: 'space-between',
                flexDirection: { xs: 'column', sm: 'row' },
                boxShadow: '0 4px 20px rgba(25, 118, 210, 0.25)',
                zIndex: 9999,
                gap: 2
            }}>
                <Stack direction="row" alignItems="center" spacing={1.5} sx={{ flex: 1 }}>
                    <AutoAwesomeRoundedIcon sx={{ fontSize: 26, color: '#FFD700', flexShrink: 0 }} />
                    <Box sx={{ flex: 1 }}>
                        <Typography variant="subtitle2" sx={{ fontWeight: 800, textTransform: 'uppercase', letterSpacing: 0.5, color: '#FFD700' }}>
                            Periodo de Prueba
                        </Typography>
                        <Typography variant="body2" sx={{ fontWeight: 500, opacity: 0.9 }}>
                            Estás descubriendo QiHotels. Tu periodo de prueba finaliza el <b>{trialEndsAt ? formatDateToYmd(trialEndsAt) : 'pronto'}</b>.
                        </Typography>
                    </Box>
                </Stack>
                <Button 
                    variant="contained" 
                    size="small"
                    sx={{ 
                        backgroundColor: '#FFD700', 
                        color: '#0d47a1',
                        fontWeight: 800, 
                        borderRadius: 2,
                        flexShrink: 0,
                        alignSelf: { xs: 'flex-end', sm: 'center' },
                        whiteSpace: 'nowrap',
                        boxShadow: '0 4px 10px rgba(255, 215, 0, 0.4)',
                        '&:hover': { backgroundColor: '#FFC107' } 
                    }}
                >
                    Adquirir Plan
                </Button>
            </Box>
        );
    }

    return null;
};
